const last2Precision = new RegExp(/^[-]?[0-9]+([.]\d{1,2})?$/);
const last4Precision = new RegExp(/^[-]?[0-9]+([.]\d{1,4})?$/);

const emailReg = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);

const sslValid = new RegExp(
  /^(-----BEGIN CERTIFICATE-----[\s\S]+-----END CERTIFICATE-----)$/,
);

//sslkey 匹配12种格式UXPSA-12862
const sslKeyValid = new RegExp(
  /^(-----*\s*BEGIN\s*(RSA|EC|DSA|OPENSSH|PGP|SSH2\sENCRYPTED|GOST|SPKI|ENCRYPTED|PUBLIC)?\s*PRIVATE\s*KEY(?:\s*BLOCK)?\s*-*\s*[\s\S]+[\s\S]*\s*-*\s*END\s*\2?\s*PRIVATE\s*KEY(?:\s*BLOCK)?\s*-*$|-----*\s*BEGIN\s*PKCS7\s*-*\s*[\s\S]+[\s\S]*\s*-*\s*END\s*PKCS7\s*-*$)$/,
);

const domainValid = new RegExp(
  /^(?![a-z0-9-]{1,63}\.[a-z]{2,}$)(?!-)(xn--)?[a-z0-9-]{1,63}(\.[a-z0-9-]{1,63})*(\.[a-z]{2,}|\.[a-z0-9-]{2,}\.[a-z]{2,}(\.[a-z]{2,})?)$/,
);

export {
  last2Precision,
  last4Precision,
  emailReg,
  sslValid,
  sslKeyValid,
  domainValid,
};
